const state = {
	breadCrumbList: [],
	isLoading:false,
	cancelRouteFlag: '',
	questTypeList: [
		{
			label: '单选',
			value: 1
		},
		{
			label: '多选',
			value: 2
		},
		{
			label: '判断',
			value: 3
		}
	],
	is_show_mobile: localStorage.getItem('is_show_mobile')
}
const mutations = {
	changeBreadCrumbList(state, data) {
		state.breadCrumbList = data
	},
	changeLoading(state, data) {
		state.isLoading = data
	},
	cancelRouter(state, data) {
		state.cancelRouteFlag = data
	},
	setIsShowMobile(state, data) {
		state.is_show_mobile = data
		localStorage.setItem('is_show_mobile', data)
	}
}
const actions = {
	
}
export default {
	state,
	mutations,
	actions
}